import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import CheckedTasksList from './CheckedTasksList';

export default ColumnsContent(CheckedTasksList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/CheckedTasksList/index.js